import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ItemDetailTabKey } from '@/enums';
import { ItemDetailTabPill } from '@/experiences/sales-portal/domain/items/components/item-detail-tab-pill';
import { View } from 'react-native';

/**
 * Props for {@link ItemDetailTabBar}.
 */
export interface ItemDetailTabBarProps {
  /** Currently selected tab. */
  activeTab: ItemDetailTabKey;
  /**
   * Curried select handler: given a tab key, returns the onPress callback for
   * that tab's pill. Lets the parent memoise once and feed stable handlers
   * into each pill.
   */
  onSelect: (tab: ItemDetailTabKey) => () => void;
}

/**
 * Pill-shaped tab bar that toggles between the General and Details panels.
 *
 * @param props - {@link ItemDetailTabBarProps}.
 * @returns The rendered tab bar.
 */
export const ItemDetailTabBar: React.FC<ItemDetailTabBarProps> = ({
  activeTab,
  onSelect,
}) => {
  const [styles] = useStyles();
  return (
    <View style={styles.tabBar}>
      <ItemDetailTabPill
        isActive={activeTab === ItemDetailTabKey.General}
        label={i18n.t('sales_portal.order_entry.item_detail.tab.general')}
        onPress={onSelect(ItemDetailTabKey.General)}
      />
      <ItemDetailTabPill
        isActive={activeTab === ItemDetailTabKey.Details}
        label={i18n.t('sales_portal.order_entry.item_detail.tab.details')}
        onPress={onSelect(ItemDetailTabKey.Details)}
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  tabBar: {
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
    paddingHorizontal: theme.sk.spacing.spaceLarge,
    paddingTop: theme.sk.spacing.spaceSmall,
  },
}));
